"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Td = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Td(_a) {
    var { isNumeric, shouldShrink } = _a, props = __rest(_a, ["isNumeric", "shouldShrink"]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "td", width: shouldShrink ? '1px' : undefined, textAlign: isNumeric ? 'right' : undefined, verticalAlign: "middle", role: "gridcell", px: 3, py: 2 }, props), void 0));
}
exports.Td = Td;
//# sourceMappingURL=index.js.map